import { defineStore } from "pinia";

export const useArticlesStore = defineStore("articles", {
  state: () => ({
    projects: [],
    articles: [],
    pending: true,
  }),
  actions: {
    async getArticles() {
      try {
        const { data } = await useFetch("/api/articles");
        this.projects = data.value || [];
        this.pending = false;
        console.log(this.articles);
      } catch (error) {
        console.error("Failed to fetch projects:", error);
        this.projects = [];
        this.pending = false;
      }
    },
    async getProjectId(id) {
      try {
        const { data } = await useFetch(`/api/article/${id}`);
        this.projects = data.value || [];
        this.pending = false;
        console.log(this.projects);
      } catch (error) {
        console.error("Failed to fetch projects:", error);
        this.projects = [];
        this.pending = false;
      }
    },
  },
});